// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1788167143079
      var cssReload = require("../../node_modules/.pnpm/mini-css-extract-plugin@2.8.1_webpack@5.97.1_esbuild@0.17.19_/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  